export const translations = {
    en: {
        nav: {
            how: "How it works",
            areas: "Service areas",
            faq: "FAQ",
            offer: "Get Offer",
        },
        tagline: "We pay instant cash",
        hero: {
            badge: "Instant offer in under 5 minutes",
            t1: "WE BUY",
            t2: "ANY CAR,",
            t3: "ANY CONDITION.",
            sub: "Running or not, wrecked, flooded, or with no title at all — we pay cash on the spot and tow it away free, anywhere in Greater Houston.",
            call: "Call (346) 318-5888",
            wa: "WhatsApp us",
            quote: "Get my offer online",
            chip1: "Cash on pickup",
            chip2: "Same-day pickup",
            imgAlt: "Car bought for cash in Houston",
            serving: "Serving Greater Houston, TX",
        },
        trust: [
            { t: "Cash Today", d: "Paid on the spot when we pick up." },
            { t: "Free Towing", d: "Zero fees — home, work or roadside." },
            { t: "With or Without Title", d: "Clean, salvage or missing title." },
            { t: "Same-Day Pickup", d: "Express pickup across Houston." },
        ],
        marquee: [
            "We buy any car", "Cash today", "Free towing",
            "With or without title", "Same-day pickup", "Any condition",
        ],
        quote: {
            eyebrow: "Free • No obligation",
            h: "Get your instant cash offer",
            sub: "Fill this out and we call you back within 15 minutes with a firm number. No fees, no pressure.",
            bullets: [
                "Firm offer within 15 minutes",
                "Free towing included — always",
                "We handle all the paperwork",
            ],
            year: "Year",
            make: "Make",
            model: "Model",
            modelPh: "e.g. F-250, Civic",
            select: "Select...",
            condition: "Does it start and drive?",
            cond: ["Runs & drives well", "Starts but doesn't drive", "Doesn't start at all"],
            title: "Do you have the title?",
            titles: ["Clean title", "Salvage title", "No title"],
            issues: "Any problems with the vehicle?",
            iss: ["Engine damage", "Transmission", "Crash / body damage", "Missing parts", "Flood damage", "Keys missing"],
            name: "Full name",
            phone: "Phone number",
            zip: "ZIP code / neighborhood",
            submit: "Get my cash offer",
            submitting: "Sending...",
            privacy: "No spam. No fees. Just a fair cash offer.",
            errSubmit: "Something went wrong — please call us instead.",
        },
        success: {
            t: "Offer requested!",
            b: "Thanks {name} — we'll call you within 15 minutes with your firm offer. Keep your phone handy.",
            call: "Call instead: (346) 318-5888",
            again: "Request another offer",
        },
        how: {
            eyebrow: "How it works",
            h: "Three steps. Cash in hand today.",
            sub: "No listings, no strangers test-driving your car, no lowballers.",
            steps: [
                { t: "Get your offer", d: "Call or send the form — a real person replies with a firm cash quote in minutes." },
                { t: "Lock the price", d: "Agree on the number. It stays firm — no hidden fees, no last-minute games." },
                { t: "We pick up & pay", d: "We tow it free and hand you cash or check on the spot." },
            ],
            band: "Free towing, anywhere in metro Houston",
        },
        areas: {
            eyebrow: "Service areas",
            h: "We come to you — anywhere in Greater Houston",
            sub: "From downtown to the suburbs, our tow trucks cover the entire metro every day of the week.",
            note: "Don't see your area? Call us — we usually still come.",
        },
        faq: {
            eyebrow: "FAQ",
            h: "Straight answers, no runaround",
            items: [
                { q: "Do you really buy cars without a title?", a: "Yes. In most cases a bill of sale plus your ID or registration is enough. Tell us your situation and we'll handle the paperwork." },
                { q: "Is towing really free?", a: "Always. The offer we quote is the cash you get — towing costs you nothing, anywhere in Greater Houston." },
                { q: "How fast can you pick up my car?", a: "Same day in most cases — often within 2 to 4 hours of your call, seven days a week." },
                { q: "What condition do you accept?", a: "Any: running or not, wrecked, flooded, burned, salvage, missing parts or missing keys." },
                { q: "How do I get paid?", a: "Cash or a verified check, handed to you the moment we load the vehicle." },
                { q: "What do you need from me?", a: "The vehicle, a valid ID, and the title if you have it. No title? We'll sort it out with you." },
            ],
        },
        footer: {
            rights: "© 2026 Cash For Cars Houston. All rights reserved.",
            line: "Licensed & insured • Serving Greater Houston, TX",
        },
        sticky: { call: "Call Now", wa: "WhatsApp" },
    },
    es: {
        nav: {
            how: "Cómo funciona",
            areas: "Áreas de servicio",
            faq: "Preguntas",
            offer: "Cotizar",
        },
        tagline: "Pagamos efectivo al instante",
        hero: {
            badge: "Oferta rápida en menos de 5 minutos",
            t1: "COMPRAMOS",
            t2: "TU AUTO,",
            t3: "EN CUALQUIER ESTADO.",
            sub: "Prenda o no, chocado, inundado o sin título — pagamos en efectivo al instante y lo remolcamos gratis en todo Greater Houston.",
            call: "Llamar: (346) 318-5888",
            wa: "WhatsApp directo",
            quote: "Cotizar en línea",
            chip1: "Efectivo al recoger",
            chip2: "Recogido el mismo día",
            imgAlt: "Auto comprado por efectivo en Houston",
            serving: "Servimos Greater Houston, TX",
        },
        trust: [
            { t: "Efectivo hoy", d: "Pagado al instante cuando recogemos." },
            { t: "Grúa gratis", d: "Cero cuotas — casa, trabajo o carretera." },
            { t: "Con o sin título", d: "Limpio, salvage o sin título." },
            { t: "Mismo día", d: "Recogida exprés en Houston." },
        ],
        marquee: [
            "Compramos cualquier auto", "Efectivo hoy", "Grúa gratis",
            "Con o sin título", "Recogida el mismo día", "Cualquier condición",
        ],
        quote: {
            eyebrow: "Gratis • Sin compromiso",
            h: "Cotiza tu auto ahora",
            sub: "Llena el formulario y te llamamos en menos de 15 minutos con una oferta firme. Sin cuotas, sin presión.",
            bullets: [
                "Oferta firme en 15 minutos",
                "Grúa gratis — siempre",
                "Nos encargamos de todo el papeleo",
            ],
            year: "Año",
            make: "Marca",
            model: "Modelo",
            modelPh: "Ej. F-250, Civic",
            select: "Seleccionar...",
            condition: "¿Enciende y camina?",
            cond: ["Prende y camina bien", "Prende pero no camina", "No prende para nada"],
            title: "¿Tienes el título?",
            titles: ["Título limpio", "Título salvage", "Sin título"],
            issues: "¿Qué problemas tiene el vehículo?",
            iss: ["Falla de motor", "Transmisión", "Chocado / carrocería", "Faltan partes", "Daño por inundación", "Sin llaves"],
            name: "Nombre completo",
            phone: "Teléfono",
            zip: "Código ZIP / colonia",
            submit: "Quiero mi oferta en efectivo",
            submitting: "Enviando...",
            privacy: "Sin spam. Sin cuotas. Solo una oferta justa.",
            errSubmit: "Algo salió mal — por favor llámanos.",
        },
        success: {
            t: "¡Oferta solicitada!",
            b: "Gracias {name} — te llamamos en menos de 15 minutos con tu oferta firme. Ten tu teléfono a la mano.",
            call: "Mejor llamo: (346) 318-5888",
            again: "Hacer otra cotización",
        },
        how: {
            eyebrow: "Cómo funciona",
            h: "Tres pasos. Efectivo hoy.",
            sub: "Sin anuncios, sin extraños probando tu carro, sin regateos.",
            steps: [
                { t: "Recibe tu oferta", d: "Llama o llena el formulario — una persona real te responde con una oferta firme en minutos." },
                { t: "Fija el precio", d: "Acuerdas la cifra y se queda firme: sin cuotas escondidas ni juegos de última hora." },
                { t: "Recogemos y pagamos", d: "Remolcamos gratis y te entregamos el efectivo o cheque al instante." },
            ],
            band: "Grúa gratis en todo el área metropolitana de Houston",
        },
        areas: {
            eyebrow: "Áreas de servicio",
            h: "Vamos por tu auto en todo Greater Houston",
            sub: "Del centro a los suburbios, nuestras grúas recorren toda el área metropolitana cada día de la semana.",
            note: "¿No ves tu zona? Llámanos — normalmente igual vamos.",
        },
        faq: {
            eyebrow: "Preguntas frecuentes",
            h: "Respuestas claras, sin rodeos",
            items: [
                { q: "¿De verdad compran autos sin título?", a: "Sí. En la mayoría de los casos basta un bill of sale con tu ID o registro. Cuéntanos tu situación y nosotros manejamos el papeleo." },
                { q: "¿La grúa es realmente gratis?", a: "Siempre. La oferta que te damos es el efectivo que recibes — la grúa no te cuesta nada en todo Greater Houston." },
                { q: "¿Qué tan rápido recogen mi auto?", a: "El mismo día en la mayoría de los casos — a menudo dentro de 2 a 4 horas de tu llamada, siete días a la semana." },
                { q: "¿Qué condiciones aceptan?", a: "Cualquiera: prendido o no, chocado, inundado, quemado, salvage, al que le falten partes o llaves." },
                { q: "¿Cómo me pagan?", a: "En efectivo o con cheque verificado, entregado en el momento en que subimos el vehículo." },
                { q: "¿Qué necesito tener?", a: "El vehículo, una identificación válida y el título si lo tienes. ¿Sin título? Lo resolvemos contigo." },
            ],
        },
        footer: {
            rights: "© 2026 Cash For Cars Houston. Todos los derechos reservados.",
            line: "Con licencia y asegurados • Greater Houston, TX",
        },
        sticky: { call: "Llamar", wa: "WhatsApp" },
    },
};

export const get = (obj, path) =>
    path.split(".").reduce((o, k) => (o == null ? o : o[k]), obj);
